import { FC } from 'react';
import { Box, Autocomplete, TextField, Checkbox, AutocompleteRenderOptionState } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface IAdditionalConditions {
  label: string;
  objectsList: IObjectAutocomplete[];
  name: string;
  handleAutocompeteChange: (newValue: IObjectAutocomplete[] | null, name: any, multiple: boolean) => void;
  multiple: boolean;
  value: IObjectAutocomplete[] | IObjectAutocomplete | null;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
}

interface IObjectAutocomplete {
  ID: string;
  Number: string;
  InsurerName: string;
}

type OptionType = IObjectAutocomplete;

const AutocompleteField: FC<IAdditionalConditions> = (
  {
    label,
    objectsList,
    name,
    handleAutocompeteChange,
    multiple,
    value,
    error,
    helperText,
    disabled
  }
) => {

  const renderOption = multiple
    ? (props: React.HTMLAttributes<HTMLLIElement>, option: OptionType, { selected }: AutocompleteRenderOptionState) => (
      <li {...props} key={option.ID}>
        <Checkbox
          icon={icon}
          checkedIcon={checkedIcon}
          style={{ marginRight: 8 }}
          checked={selected}
        />
        {option.Number} - {option.InsurerName}
      </li>
    )
    : (props: React.HTMLAttributes<HTMLLIElement>, option: OptionType) => (
      <li {...props} key={option.ID}>
        {option.Number} - {option.InsurerName}
      </li>
    );

  return (
    <Box>
      <Autocomplete
        multiple={multiple}
        options={objectsList}
        disableCloseOnSelect={multiple}
        getOptionLabel={(option) => option.Number}
        isOptionEqualToValue={(option, value) => option.ID === value.ID}
        value={value}
        onChange={(event, newValue: OptionType | OptionType[] | null) => {
          handleAutocompeteChange(newValue as IObjectAutocomplete[] | null, name, multiple);
        }}
        renderOption={renderOption}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            error={error}
            helperText={error}
          />
        )}
      />
    </Box>
  );
};

export default AutocompleteField;